import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/employment/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/employment/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/employment/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = (params, headers) => request({
  url: '/api/mcc-staff/employment/update',
  method: 'post',
  headers,
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/employment/remove',
  method: 'post',
  params: {
    ids,
  },
})
export default {
  getList,
  add,
  detail,
  update,
  remove,
}
